import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "panel", "trigger", "close"]

  connect() {
    this.closeOnEscape = this.closeOnEscape.bind(this)
    this.closeBeforeCache = this.close.bind(this)
    document.addEventListener("keydown", this.closeOnEscape)
    document.addEventListener("turbo:before-cache", this.closeBeforeCache)
  }

  disconnect() {
    document.removeEventListener("keydown", this.closeOnEscape)
    document.removeEventListener("turbo:before-cache", this.closeBeforeCache)
    document.documentElement.classList.remove("overflow-hidden")
  }

  open() {
    this.overlayTarget.classList.remove("hidden")
    this.panelTarget.classList.remove("-translate-x-full")
    if (this.panelTarget.hasAttribute("data-sidebar-modal")) {
      this.panelTarget.inert = false
      this.panelTarget.setAttribute("aria-hidden", "false")
    }
    this.triggerTargets.forEach((trigger) => trigger.setAttribute("aria-expanded", "true"))
    document.documentElement.classList.add("overflow-hidden")
    if (this.hasCloseTarget) requestAnimationFrame(() => this.closeTarget.focus())
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    this.panelTarget.classList.add("-translate-x-full")
    if (this.panelTarget.hasAttribute("data-sidebar-modal")) {
      this.panelTarget.inert = true
      this.panelTarget.setAttribute("aria-hidden", "true")
    }
    this.triggerTargets.forEach((trigger) => trigger.setAttribute("aria-expanded", "false"))
    document.documentElement.classList.remove("overflow-hidden")
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && !this.overlayTarget.classList.contains("hidden")) this.close()
  }
}
